import {render} from "@testing-library/react";
import React, {useState, useEffect, useRef} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {
  loginUser,
  resetUserEmail,
  verifyLoginCode,
  setAuthCode,
} from "../authRequests";
import {
  loadDataForPatientLogin,
  crud,
  viewOrganizationByUrl,
  viewCustomers,
} from "../crudRequests";
import clientInfo from "../additional_files/loginInfo";
import CodeForm from "../components/Login+CodeForm";
import ForgotPwdForm from "../components/ForgotPwdForm";
import ResetPwdForm from "../components/ResetPwdForm";
import axios from "axios";
import {signInDestination} from "../lib/signInDestination";
import {FaHospitalUser} from "react-icons/fa";
import {FiMail, FiLock, FiChevronDown, FiEye, FiEyeOff} from "react-icons/fi";
export default function Login() {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const authErrorRef = useRef(null);
  const serverErrorRef = useRef(null);
  const loadedRef = useRef(null);
  const loaderRef = useRef(null);
  const loginLoaderRef = useRef(null);

  const [codeForm, setCodeForm] = useState(false);
  const [forgotPwdForm, setForgotPwdForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const logingData = useRef(null);
  const sendCodeData = useRef(null);
  const navigate = useNavigate();
  const [urlBasedOrg, setUrlBasedOrg] = useState();
  const [customers, setCustomers] = useState([]);
  let {db} = useParams();

  //console.log(db);
  useEffect(
    function () {
      if (!window.location.href.includes("?reset=")) {
        viewCustomers()
          .then((c) => {
            if (c.data?.[0]) {
              if (db) {
                let cust = c.data?.find((customers) => customers.db === db);
                if (cust) {
                  setUrlBasedOrg(cust);
                } else {
                  window.location.href = "../login";
                }
              } else {
                setUrlBasedOrg(c.data?.[0]);
                setCustomers(c.data);
              }
            }
          })
          .catch((e) => console.error);
      }
    },
    [db]
  );

  async function login(e) {
    // Unconditionally, and FIRST. The clinic is resolved by a request that has
    // usually landed by the time anyone types, but not always — and when it had
    // not, this returned without preventing the default, so the browser
    // submitted the form itself: a full page reload that threw away the
    // password and left no error behind. A submit handler that sometimes lets
    // the browser win is a submit handler with a silent failure in it.
    e.preventDefault();
    if (urlBasedOrg) {
      authErrorRef.current.className = "hidden";
      serverErrorRef.current.className = "hidden";
      loginLoaderRef.current.className = "inline-block";

      loginUser(
        emailRef.current.value,
        passwordRef.current.value,
        "patient",
        urlBasedOrg.db
      )
        .then(async (res) => {
          let {user} = res.data||{};
          const relatedPatient = res.data?.patient || null;
          let {jwt, userType, db, tfa, guardianOf} = user||{};
          logingData.current = {
            jwt,
            patient: relatedPatient || user,
            destination: signInDestination(window.location.search),
            db,
            userType: userType||"patient",
            relationship: userType==="relationship"?user:null,
            guardianOf: Array.isArray(guardianOf) ? guardianOf : [],
            firstLoading: true,
          };
          if (tfa) {
            sendCodeData.current = {
              jwt,
              userType: userType,
              user,
              db,
              organization: urlBasedOrg,
            };
            setAuthCode({
              ...sendCodeData.current,
            }).then((r) => {
              setCodeForm(true);
            });
          } else {
            loaderRef.current.className = "block";
            loadedRef.current.className = "hidden";
            loadDataForPatientLogin(
              {
                ...logingData.current,
                destination: signInDestination(window.location.search),
              },
              navigate
            );

            let jsonIp = await axios({
              url: "https://api.ipify.org?format=json",
            });
            let userId = userType === "relationship" ? user.rid : user.id;

            crud({jwt: jwt}, [
              {
                db: db,
                collection: "security",
                parameters: [
                  {userId},
                  {
                    $push: {
                      logins: {
                        ip: jsonIp.data.ip,
                        client: clientInfo(),
                        timestamp: new Date(),
                      },
                    },
                  },
                  {upsert: true},
                ],
                method: "findOneAndUpdate",
              },
            ]);
          }
        })
        .catch((err) => {
          console.log(err.message);
          if (err.response?.status === 403) {
            loginLoaderRef.current.className = "hidden";
            authErrorRef.current.className = "block w-full";
          } else if (
            err.response?.status === 404 ||
            err.response?.status === 500
          ) {
            loginLoaderRef.current.className = "hidden";
            serverErrorRef.current.className = "block w-full";
          } else console.log(err.response);
        });
    }
  }

  return (
    <div className="h-full w-full md:grid md:grid-cols-5 ">
      {/* Left graphic */}
      <div
        className="relative hidden md:block md:col-span-2 lg:col-span-3 overflow-hidden bg-gradient-to-br from-sky-50 via-indigo-50 to-fuchsia-50 animate-gradient-drift"
        aria-hidden="true"
      >
        {/* soft dot grid */}
        <div className="absolute inset-0 bg-[radial-gradient(#00000008_1px,transparent_1px)] bg-[size:16px_16px]" />
        {/* floating orbs */}
        <div
          className="absolute -top-24 -left-10 h-72 w-72 bg-indigo-500/30 rounded-full blur-3xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "30px", "--ty": "-20px", "--dur": "18s"}}
        />
        <div
          className="absolute top-10 right-[-4rem] h-96 w-96 bg-fuchsia-500/25 rounded-full blur-3xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "-28px", "--ty": "16px", "--dur": "22s"}}
        />
        <div
          className="absolute bottom-[-3rem] left-1/3 h-80 w-80 bg-violet-500/25 rounded-full blur-3xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "24px", "--ty": "18px", "--dur": "20s"}}
        />
        <div
          className="absolute top-1/4 left-8 h-40 w-40 bg-violet-500/25 rounded-full blur-2xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "20px", "--ty": "-14px", "--dur": "17s"}}
        />
        <div
          className="absolute top-1/3 right-24 h-52 w-52 bg-fuchsia-500/25 rounded-full blur-2xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "-18px", "--ty": "12px", "--dur": "19s"}}
        />
        <div
          className="absolute bottom-16 right-10 h-44 w-44 bg-indigo-500/25 rounded-full blur-2xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "-22px", "--ty": "-10px", "--dur": "21s"}}
        />
        <div
          className="absolute bottom-24 left-10 h-28 w-28 bg-purple-500/25 rounded-full blur-2xl animate-float-xy animate-hue-rotate"
          style={{"--tx": "18px", "--ty": "8px", "--dur": "16s"}}
        />

        {/* glassy badge with favicon */}
        <div className="absolute bottom-10 left-10 backdrop-blur-md bg-white/30 border border-white/40 rounded-full p-3 shadow-lg animate-float-slow">
          <img src="/favicon.png" alt="Brightlight" className="h-6 w-6" />
        </div>

        {/* gentle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-white/30" />
      </div>

      {/* Right panel */}
      <div className="flex h-full  md:col-span-3 lg:col-span-2 items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-blue-50 px-6 md:px-10 lg:px-12 py-10">
        <div className="w-full max-w-md">
          <div ref={loaderRef} className="hidden">
            <div className="border p-[6.5rem] rounded-md">
              <div className="flex justify-center align-middle">
                <img src="/images/loader.gif" className="h-36" alt="Loading" />
              </div>
            </div>
          </div>

          {codeForm ? (
            <CodeForm
              logingData={logingData.current}
              navigate={navigate}
              sendCodeData={sendCodeData.current}
              org={urlBasedOrg}
            />
          ) : forgotPwdForm ? (
            <ForgotPwdForm
              navigate={navigate}
              org={urlBasedOrg}
              onBack={() => setForgotPwdForm(false)}
            />
          ) : window.location.href.includes("?reset=") ? (
            <ResetPwdForm navigate={navigate} />
          ) : (
            <div ref={loadedRef} className="w-full max-w-md">
              <form
                onSubmit={login}
                className="w-full border border-gray-100 bg-white/80 backdrop-blur-md shadow-2xl rounded-2xl p-10 sm:p-12"
                style={{minHeight: 520}}
              >
                <div className="mb-4 h-16 flex items-center justify-center">
                  <div className="h-full flex items-center py-3">
                    {urlBasedOrg?.logo ? (
                      <img
                        src={urlBasedOrg.logo}
                        className="h-full w-auto object-contain"
                        alt={`${urlBasedOrg?.name || "Clinic"} logo`}
                      />
                    ) : (
                      <FaHospitalUser className="text-[#6772e5]" size={44} />
                    )}
                  </div>
                </div>
                <div className="text-center mb-6">
                  <h2 className="text-xl font-semibold text-slate-800">
                    Welcome back
                  </h2>
                  <p className="text-sm text-slate-500">
                    {urlBasedOrg?.name
                      ? `Sign in to ${urlBasedOrg.name}`
                      : "Sign in to continue"}
                  </p>
                </div>
                <div
                  className="hidden w-full flex justify-center"
                  ref={authErrorRef}
                >
                  <div
                    role="alert"
                    className="mb-2 w-full rounded-xl border border-red-200/70 bg-red-50/80 px-4 py-2.5 text-red-700 shadow-sm backdrop-blur"
                  >
                    <div className="flex items-start gap-3 text-left">
                      <span className="mt-1 inline-block h-2 w-2 rounded-full bg-red-400 ring-4 ring-red-100"></span>
                      <div className="flex-1">
                        <p className="font-semibold">Sign-in error</p>
                        <p className="text-sm">Invalid email or password.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="hidden w-full flex justify-center"
                  ref={serverErrorRef}
                >
                  <div
                    role="alert"
                    className="mb-2 w-full rounded-xl border border-amber-200/70 bg-amber-50/80 px-4 py-2.5 text-amber-800 shadow-sm backdrop-blur"
                  >
                    <div className="flex items-start gap-3 text-left">
                      <span className="mt-1 inline-block h-2 w-2 rounded-full bg-amber-400 ring-4 ring-amber-100"></span>
                      <div className="flex-1">
                        <p className="font-semibold">Something went wrong</p>
                        <p className="text-sm">Please try again in a moment.</p>
                      </div>
                    </div>
                  </div>
                </div>

                {customers.length > 0 && (
                  <div className="w-full">
                    <div className="input-group relative">
                      <select
                        aria-label="Select clinic"
                        name="clinic"
                        id="clinic"
                        onChange={(e) =>
                          setUrlBasedOrg(customers[e.target.value])
                        }
                        className="input appearance-none w-full py-3 px-4 pr-10 rounded-lg my-2 bg-white border border-gray-200 focus:border-[#6772e5] focus:ring-2 focus:ring-[#6772e5]/40 transition"
                      >
                        {customers.map((c, i) => (
                          <option value={i} key={i}>
                            {c.name}
                          </option>
                        ))}
                      </select>
                      <FiChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
                    </div>
                  </div>
                )}
                <div className="input-group with-icon relative">
                  <FiMail className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    id="email"
                    ref={emailRef}
                    required
                    autoComplete="username"
                    className="input w-full py-3 pl-10 pr-4 rounded-lg my-2 bg-white border border-gray-200 focus:border-[#6772e5] focus:ring-2 focus:ring-[#6772e5]/40 transition"
                  />
                  <label htmlFor="email" className="input-label">
                    Email/Phone
                  </label>
                </div>
                <div className="input-group with-icon relative">
                  <FiLock className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    ref={passwordRef}
                    required
                    autoComplete="current-password"
                    className="input w-full py-3 pl-10 pr-12 rounded-lg my-2 bg-white border border-gray-200 focus:border-[#6772e5] focus:ring-2 focus:ring-[#6772e5]/40 transition"
                    style={{
                      fontFamily: showPassword ? "inherit" : "password",
                      letterSpacing: showPassword ? "normal" : "2px",
                    }}
                  />
                  <label htmlFor="password" className="input-label">
                    Password
                  </label>
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span
                    className="text-[#6772e5] font-medium text-xs mt-2 cursor-pointer hover:underline"
                    onClick={() => {
                      setForgotPwdForm(true);
                    }}
                  >
                    Forgot Password?
                  </span>

                  <button
                    type="submit"
                    disabled={!urlBasedOrg}
                    className="inline-flex items-center justify-center p-2.5 px-5 rounded-lg my-2 bg-[#6772e5] hover:bg-[#5b63d3] text-white font-medium text-sm cursor-pointer shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6772e5] transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Login
                    <span ref={loginLoaderRef} className="hidden">
                      <svg
                        className="animate-spin ml-2 -mb-0.5 -mr-1 h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    </span>
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
